import { Empresa } from "./Empresa";
import { MBase } from "./MBase";

export class MBaseEmpresa extends MBase{
  EmpresaId: number;
  Empresa: Empresa;
}
